<template>
  <div>
    <DeleteModal modalId="modal-delete" @deleteToggle="deleteItem" />

    <b-modal
      :no-close-on-backdrop="true"
      id="modal-edit"
      ok-only
      centered
      size="lg"
      :title="
        createMode
          ? $t('lab.add-test-report-fields')
          : $t('lab.edit-test-report-fields')
      "
    >
      <b-card-text>
        <b-row>
          <b-col md="">
            <b-form-group
              :label="$t('lab.test-report-field-name')"
              label-for="name"
              class="required"
            >
              <b-form-input
                v-model="EditForm.name"
                :placeholder="$t('lab.test-report-field-name')"
              />
              <p class="text-danger mt-1">{{ errorForm.name }}</p>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="6">
            <b-form-group :label="$t('lab.category')" label-for="category">
              <b-form-input
                v-model="EditForm.category"
                :placeholder="$t('lab.category')"
              />
              <p class="text-danger mt-1">{{ errorForm.category }}</p>
            </b-form-group>
          </b-col>

          <!-- <b-col md="6">
            <b-form-group :label="$t('lab.type')" label-for="type">
              <v-select
                v-model="EditForm.type"
                :options="['string', 'number']"
                placeholder="string, number"
              />
              <p class="text-danger mt-1">{{ errorForm.type }}</p>
            </b-form-group>
          </b-col> -->

          <!-- Is Required -->
          <b-col md="6">
            <b-form-group
              :label="$t('lab.is_required')"
              label-for="is_required"
            >
              <v-select
                v-model="EditForm.is_required"
                :options="[
                  { text: $t('lab.required'), value: 1 },
                  { text: $t('lab.not-required'), value: 0 },
                ]"
                placeholder="Required, Not Required"
                :reduce="(item) => item.value"
                label="text"
              />
              <p class="text-danger mt-1">{{ errorForm.is_required }}</p>
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group :label="$t('lab.default')" label-for="default">
              <b-form-input
                v-model="EditForm.default"
                :placeholder="$t('lab.default')"
              />
              <p class="text-danger mt-1">{{ errorForm.default }}</p>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="9" cols="12">
            <b-form-group :label="$t('lab.options')" label-for="options">
              <b-form-input v-model="option" :placeholder="$t('lab.options')" />
            </b-form-group>
            <p class="text-danger mt-1">
              {{ errorForm.options.length > 0 ? errorForm.options : "" }}
            </p>
          </b-col>
          <b-col md="3" style="margin-top: 25px">
            <b-button variant="primary" @click="addOption" class="m-0" block>
              {{ $t("common.add") }}
            </b-button>
          </b-col>

          <b-col md="12">
            <div class="border d-flex flex-row">
              <b-badge
                v-for="selected_option in EditForm.options"
                :key="selected_option"
                class="m-1"
                style="cursor: pointer"
                :variant="
                  hoveredOption === selected_option ? 'danger' : 'secondary'
                "
                @click="deleteOption(selected_option)"
                @mouseover="hoveredOption = selected_option"
                @mouseleave="hoveredOption = null"
              >
                {{ selected_option }}
              </b-badge>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="12" class="mt-2">
            <b-form-group
              :label="$t('lab.reference-range')"
              label-for="reference_range"
            >
              <b-form-input
                v-model="EditForm.reference_range"
                :placeholder="$t('lab.reference-range')"
              />
              <p class="text-muted mt-1">
                Example: 10-20 cm / 10-20 mm , Yellow-Green
              </p>
              <p class="text-danger mt-1">{{ errorForm.reference_range }}</p>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
      <template #modal-footer="{}">
        <b-button
          variant="primary"
          @click="submitItem"
          class="m-0"
          :disabled="loading"
          ref="button"
          block
        >
          <span v-if="!loading">{{
            createMode ? $t("common.add") : $t("common.edit")
          }}</span>
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>
    </b-modal>

    <b-card :title="$t('bloodBank.filter-blood-store')">
      <div>
        <!-- Search form -->
        <b-row class="mt-3">
          <b-col md="6" cols="12">
            <AutoComplete
              :label="$t('lab.patient_name')"
              :placeholder="$t('lab.patient_name')"
              v-model="testReportFieldSearch"
              :serializer="(val) => val.name"
              param-query="filter[id]=-id"
              other-query="filter[test_report_id]"
              endpoint="testReportField"
              text-title="name"
              style="flex: 1"
            />
          </b-col>
          <b-col md="6" cols="12">
            <b-form-group
              :label="$t('common.created-at')"
              label-for="production_date"
            >
              <datepicker
                v-model="from_date"
                :calendar-button="true"
                :clear-button="true"
                :bootstrap-styling="true"
                class="datebtn2"
                placeholder="YYYY-MM-DD"
              ></datepicker>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Search Button -->
        <b-row>
          <b-col cols="12" md="12">
            <br />
          </b-col>
          <b-col
            cols="12"
            md="12"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <b-button variant="primary" @click="getTestReportField()">
              {{ $t("common.search") }}
              <b-icon-search class="ml-1"></b-icon-search>
            </b-button>
            <!-- <b-button variant="primary" v-print="IVF" class="mx-2">
                            {{ $t("surgery.Print-Hospital-Expenses") }}
                        </b-button> -->
          </b-col>
        </b-row>

        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>
            {{ $t("lab.report-fields-for") }}
            {{ $route.params.test_report_name }} {{ $t("lab.test-null") }}
          </h2>
          <b-button variant="primary" @click="show(EditForm, 'create')">
            {{ $t("lab.add-test-report-fields") }}
          </b-button>
        </div>

        <b-table
          :items="data"
          responsive
          :fields="bloodBottleTableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
        >
          <template #cell(is_required)="data">
            <b-badge v-if="data.item.is_required == '1'" variant="danger">{{
              $t("lab.required")
            }}</b-badge>
            <b-badge v-else variant="success">{{
              $t("lab.not-required")
            }}</b-badge>
          </template>
          <template #cell(options)="data">
            <ol v-if="data.item.options">
              <li
                v-for="(option, index) in JSON.parse(data.item.options)"
                :key="index"
                style="margin: 5px 0px"
              >
                <b-badge variant="primary">{{ option }}</b-badge>
              </li>
            </ol>
            <span v-else>
              <ol style="list-style-type: none">
                <li>
                  <b-badge variant="secondary">
                    {{ $t("lab.no-options") }}
                  </b-badge>
                </li>
              </ol>
            </span>
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <ActionsButtons
                deletePerm="update-patient"
                editPerm="update-patient"
                @editToggle="show(data.item)"
                @deleteToggle="deleteModel(data.item)"
              />
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner label="Loading..." />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getTestReportField()"
            >
              <b-pagination
                v-model="page"
                :total-rows="dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>

    <IVF :data="data" type="Hospital" />
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BFormCheckbox,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BFormTextarea,
  BFormSelect,
  BFormDatepicker,
  BBadge,
  BCardText,
  BFormRadioGroup,
  BFormRadio,
} from "bootstrap-vue";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import VuePhoneNumberInput from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import Datepicker from "vuejs-datepicker";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
const IVF = () => import("@/components/printables/IVF.vue");
const Doctor = () => import("@/components/printables/Doctor.vue");
import permissionChecker from "@/mixins/permissionChecker";
import DeleteModal from "@/components/modals/DeleteModal.vue";
import ActionsButtons from "@/components/common/ActionsButtons.vue";
import AutoComplete from "@/components/common/AutoComplete.vue";
export default {
  mixins: [permissionChecker],

  components: {
    DeleteModal,
    BFormCheckbox,
    ActionsButtons,
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    VuePhoneNumberInput,
    Datepicker,
    BFormTextarea,
    StatisticCardHorizontal,
    BBadge,
    IVF,
    Doctor,
    BFormSelect,
    BFormDatepicker,
    BCardText,
    vSelect,
    BFormRadioGroup,
    BFormRadio,
    AutoComplete,
  },
  data() {
    return {
      take: 1000,
      loading: true,
      dataCount: 0,
      data: [],
      EditForm: {
        name: "",
        test_report_id: "",
        category: "",
        type: "",
        is_required: 1,
        required_range: "",
        default: "",
        options: [],
        _method: "PUT",
      },
      createMode: false,
      errorForm: {
        name: "",
        test_report_id: "",
        category: "",
        type: "",
        is_required: "",
        required_range: "",
        default: "",
        options: [],
      },
      params: {
        form: {},
        path: "",
      },
      bloodBottleTableColumns: [
        {
          key: "name",
          sortable: true,
          label: this.$t("lab.field-name"),
        },
        {
          key: "is_required",
          sortable: true,
          label: this.$t("lab.is-required"),
        },
        {
          key: "reference_range",
          sortable: true,
          label: this.$t("lab.reference-range"),
        },
        {
          key: "category",
          sortable: true,
          label: this.$t("lab.category"),
        },
        // {
        //   key: "type",
        //   sortable: true,
        //   label: this.$t("lab.type"),
        // },
        {
          key: "default",
          sortable: true,
          label: this.$t("lab.default"),
        },
        {
          key: "options",
          sortable: true,
          label: this.$t("lab.options"),
        },
        {
          key: "created_at",
          sortable: true,
          label: this.$t("common.created-at"),
        },

        {
          key: "Actions",
          label: this.$t("common.actions"),
          thStyle: { width: "150px" },
        },
      ],

      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      page: 1,
      IVF: {
        id: "IVF",
      },

      reference_range: "",
      rh: "",
      production_date: "",
      expiration_date: "",
      name: "",
      inserted_at: "",

      statusOptions: ["available", "dispensed"],
      searchDate: "",
      selectedSearch: "",
      from_date: "",
      to_date: "",
      type: "",
      test_report_id: "",
      test_report_fields: [],
      test_report_fields_count: 0,
      option: "",
      hoveredOption: null,
      requiredOptions: [
        { text: this.$t("lab.required"), value: 1 },
        { text: this.$t("lab.not-required"), value: 0 },
      ],
      testReportFieldSearch: "",
    };
  },
  mounted() {
    this.getTestReportField();
    this.EditForm.test_report_id = this.$route.params.test_report_id;
  },
  watch: {
    searchDate(newVal) {
      this.selectedSearch = newVal || "";
    },
  },
  methods: {
    testofication(title, message, variant = "info", icon = "success") {
      this.$toast({
        component: ToastificationContent,
        position: "top-right",
        props: {
          title: title,
          icon: icon,
          variant: variant,
          text: message,
        },
      });
    },
    addOption() {
      let isExist = this.EditForm.options.find((item) => item == this.option);
      if (this.option && !isExist) {
        this.EditForm.options.push(this.option);
        this.option = "";
      } else {
        this.testofication("Add Option", "Option already exists", "danger");
      }
    },
    deleteOption(option) {
      this.EditForm.options = this.EditForm.options.filter(
        (item) => item !== option
      );
    },
    formatDate(ivfDate) {
      const date = new Date(ivfDate);
      const year = date.getFullYear();
      let month = "" + (date.getMonth() + 1);
      let day = "" + date.getDate();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return `${year}-${month}-${day}`;
    },
    show(item, mode) {
      console.log("item", item);
      if (mode === "create") {
        this.createMode = true;
        this.EditForm = {
          _method: "POST",
          test_report_id: this.$route.params.test_report_id,
          is_required: item.is_required === 1 ? 1 : 0,
          options: [],
        };
      } else {
        this.createMode = false;
        this.EditForm.id = item.id;
        this.EditForm.name = item.name;
        this.EditForm.test_report_id = item.test_report_id;
        this.EditForm.category = item.category;
        this.EditForm.type = item.type;
        this.EditForm.is_required = item.is_required === 1 ? 1 : 0;
        this.EditForm.reference_range = item.reference_range;
        this.EditForm.default = item.default;
        this.EditForm.options = JSON.parse(item.options);

        this.EditForm._method = "PUT";
      }
      this.$bvModal.show("modal-edit");
    },
    async getTestReportField() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/testReportField?page=${this.page}&take=${
        this.searchDate && (this.from_date || this.to_date) ? 1000 : 15
      }&sort=-id&include=testReport&filter[test_report_id]=${
        this.$route.params.test_report_id
      }`;

      if (this.testReportFieldSearch) {
        url += `&filter[name]=${this.testReportFieldSearch}`;
      }

      if (this.from_date) {
        url += `&filter[created_at]=${this.formatDate(
          this.from_date
        )}`;
      }

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-delete");
    },
    deleteItem() {
      this.$store
        .dispatch("delete", `/testReportField/${this.deleteForm.id}`)
        .then((response) => {
          this.getTestReportField();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text: "deleted " + this.deleteForm.name + " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.name,
            },
          });
        });
    },

    submitItem() {
      console.log("EditForm", this.EditForm);
      // alert(this.EditForm.is_required);
      let count = 0;
      this.loading = true;
      this.errorForm.name = "";
      this.errorForm.reference_range = "";
      this.errorForm.options = "";
      this.errorForm.type = "";
      this.errorForm.category = "";
      this.errorForm.is_required = "";
      this.errorForm.default = "";
      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] !== 0) {
          if (this.EditForm[item] == "" || this.EditForm[item] == null)
            delete this.EditForm[item];
        }
      }

      // alert(this.EditForm.is_required);
      if (!this.EditForm.name) {
        count++;
        this.errorForm.name = "The field name is required.";
      }
      if (!this.EditForm.reference_range) {
        count++;
        this.errorForm.reference_range = "The reference range is required.";
      }
      // if (!this.EditForm.type) {
      //   count++;
      //   this.errorForm.type = "The type is required.";
      // }
      if (!this.EditForm.category) {
        count++;
        this.errorForm.category = "The category is required.";
      }
      //   if (!this.EditForm.options) {
      //     count++;
      //     this.errorForm.options = "The options are required.";
      //   }
      if (this.EditForm.is_required == null) {
        count++;
        this.errorForm.is_required = "The is required field is required.";
      }
      //   if (!this.EditForm.default ) {
      //     count++;
      //     this.errorForm.default = "The default is required.";
      //   }

      //   console.log("editForm", this.EditForm);
      if (count > 0) {
        this.loading = false;
        return false;
      }

      if (this.createMode) {
        (this.params.form = this.EditForm),
          (this.params.path = `/testReportField`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.$bvModal.hide("modal-edit");
              this.loading = false;
              this.getTestReportField();
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditForm),
          (this.params.path = `/testReportField/${this.EditForm.id}`),
          this.$store
            .dispatch("update", this.params)
            .then((response) => {
              this.$bvModal.hide("modal-edit");
              this.loading = false;
              this.getTestReportField();
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
